import { cbi_operational_control_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiOperationalControlEnum = (enumValue: cbi_operational_control_enum) => {
  switch (enumValue) {
    case cbi_operational_control_enum.LANDLORD_CONTROLLED:
      return <Trans i18nKey="Enum_CbiOperationalControlEnum-LANDLORD_CONTROLLED" />;
    case cbi_operational_control_enum.TENANT_CONTROLLED:
      return <Trans i18nKey="Enum_CbiOperationalControlEnum-TENANT_CONTROLLED" />;
  }
};

export const translateCbiOperationalControlEnum_dynamic = (enumValue: cbi_operational_control_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_operational_control_enum.LANDLORD_CONTROLLED:
      return t('Enum_CbiOperationalControlEnum-LANDLORD_CONTROLLED');
    case cbi_operational_control_enum.TENANT_CONTROLLED:
      return t('Enum_CbiOperationalControlEnum-TENANT_CONTROLLED');
  }
};
